<template>
  <div>
    <!-- 新增按钮 -->
    <a-row :gutter="24">
      <a-col :span="12" style="margin: 10px">
        <a-button
          type="primary"
          @click="openAddVisible"
          :disabled="form.priorityHolder.length >= 1 || !isEditable"
        >
          新增优先承租人
        </a-button>
      </a-col>
    </a-row>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :data-source="form.priorityHolder"
      :pagination="false"
      :scroll="{ x: 950 }"
      rowKey="id"
    >
      <span slot="index" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>

      <span slot="priorityLesseeType" slot-scope="text">
        {{ getPriorityLesseeTypeText(text) }}
      </span>

      <span slot="action" slot-scope="text, record, index">
        <template v-if="isEditable" >
          <a style="color: #1890ff" @click="editRow(record, index)">编辑</a>
          <a-divider type="vertical" />
        </template>
        <a style="color: #1890ff" @click="viewRow(record)">查看</a>
        <template v-if="isEditable" >
          <a-divider type="vertical" />
          <a style="color: #1890ff" @click="deleteRow(index)">删除</a>
        </template>
      </span>
    </a-table>

    <!-- 新增/编辑/查看弹窗 -->
    <a-modal
      :visible="addVisible"
      :footer="null"
      width="800px"
      @cancel="closeAddModule"
      destroyOnClose
      :maskClosable="false"
    >
      <h2 class="title">{{ modalTitle }}</h2>

      <a-form-model
        ref="formRef"
        :model="priorityFormData"
        :rules="priorityRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
        class="add-lessee"
      >
        <!-- 优先承租人类型 -->
        <a-form-model-item label="优先承租人类型" prop="priorityLesseeType">
          <a-radio-group
            v-model="priorityFormData.priorityLesseeType"
            :disabled="isView"
            @change="handlePriorityLesseeTypeChange"
          >
            <a-radio value="A11001">法人或其分支机构、其他经济组织</a-radio>
            <a-radio value="A11002">自然人</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 优先承租人名称 -->
        <a-form-model-item label="优先承租人名称" prop="priorityLesseeName">
          <a-input
            v-model="priorityFormData.priorityLesseeName"
            placeholder="请输入优先承租人名称"
            :disabled="isView"
            :maxLength="100"
          />
        </a-form-model-item>

        <!-- 统一社会信用代码 -->
        <a-form-model-item
          label="统一社会信用代码"
          prop="certCode"
          v-if="priorityFormData.priorityLesseeType == 'A11001'"
        >
          <a-input
            v-model="priorityFormData.certCode"
            placeholder="请输入统一社会信用代码"
            :disabled="isView"
            :maxLength="18"
          />
        </a-form-model-item>

        <!-- 优先承租人证件类型 -->
        <a-form-model-item
          label="优先承租人证件类型"
          prop="certType"
          v-if="priorityFormData.priorityLesseeType == 'A11002'"
        >
          <a-radio-group v-model="priorityFormData.certType" :disabled="isView">
            <a-radio style="margin: 4px 0px" value="0">身份证</a-radio>
            <a-radio style="margin: 4px 0px" value="1">护照</a-radio>
            <a-radio style="margin: 4px 0px" value="2">军官证</a-radio>
            <a-radio style="margin: 4px 0px" value="3">士兵证</a-radio>
            <a-radio style="margin: 4px 0px" value="4">回乡证</a-radio>
            <a-radio style="margin: 4px 0px" value="5">户口本</a-radio>
            <a-radio style="margin: 4px 0px" value="6">外国护照</a-radio>
            <a-radio style="margin: 4px 0px" value="15">台胞证</a-radio>
            <a-radio style="margin: 4px 0px" value="16"
              >港澳台居民身份证</a-radio
            >
            <a-radio style="margin: 4px 0px" :value="99">其它</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 证件编号 -->
        <a-form-model-item
          label="证件编号"
          prop="certCode"
          v-if="priorityFormData.priorityLesseeType == 'A11002'"
        >
          <a-input
            v-model="priorityFormData.certCode"
            placeholder="请输入证件编号"
            :disabled="isView"
            :maxLength="50"
          />
        </a-form-model-item>

        <!-- 按钮 -->
        <a-form-model-item
          :wrapper-col="{ span: 24 }"
          style="text-align: center"
        >
          <a-button style="margin-right: 16px" @click="closeAddModule">
            {{ isView ? "关闭" : "取消" }}
          </a-button>
          <a-button v-if="!isView" type="primary" @click="submitForm">
            确定
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "优先承租人名称",
    dataIndex: "priorityLesseeName",
    width: 260,
  },
  {
    title: "优先承租人类型",
    dataIndex: "priorityLesseeType",
    width: 260,
    scopedSlots: { customRender: "priorityLesseeType" },
  },
  {
    title: "证件编号",
    dataIndex: "certCode",
    width: 280,
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    fixed: "right",
    width: 200,
  },
];

export default {
  name: "PriorityLessee",
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      columns,
      addVisible: false,
      editIndex: null,
      modalType: "add", // add / edit / view

      priorityFormData: {
        priorityLesseeType: "A11001",
        priorityLesseeName: undefined,
        certType: undefined,
        certCode: undefined,
      },

      priorityRules: {
        priorityLesseeType: [
          {
            required: true,
            message: "请选择优先承租人类型",
            trigger: "change",
          },
        ],
        priorityLesseeName: [
          {
            required: true,
            message: "请输入优先承租人名称",
            trigger: "blur",
          },
        ],
        certType: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.priorityFormData.priorityLesseeType === "A11002") {
                if (value === undefined || value === null || value === "") {
                  callback(new Error("请选择证件类型"));
                  return;
                }
              }
              callback();
            },
            trigger: "change",
          },
        ],
        certCode: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || !String(value).trim()) {
                callback(new Error("请输入统一社会信用代码/证件编号"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    isView() {
      return this.modalType === "view";
    },
    modalTitle() {
      if (this.modalType === "edit") return "编辑优先承租人";
      if (this.modalType === "view") return "查看优先承租人";
      return "新增优先承租人";
    },
  },

  methods: {
    getPriorityLesseeTypeText(value) {
      if (value === "A11001") return "法人或其分支机构、其他经济组织";
      if (value === "A11002") return "自然人";
      return "--";
    },

    getDefaultFormData() {
      return {
        priorityLesseeType: "A11001",
        priorityLesseeName: undefined,
        certType: undefined,
        certCode: undefined,
      };
    },

    resetFormData() {
      this.priorityFormData = this.getDefaultFormData();
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 打开新增
    openAddVisible() {
      if (this.form.priorityHolder.length >= 1) {
        this.$notification.warning({
          message: "优先承租人有且只有一个，请编辑或删除现有数据",
          description: `失败`,
        });
        return;
      }
      this.modalType = "add";
      this.editIndex = null;
      this.resetFormData();
      this.addVisible = true;
    },

    // 关闭弹窗
    closeAddModule() {
      this.addVisible = false;
      this.editIndex = null;
      this.modalType = "add";
      this.resetFormData();
    },

    // 类型切换时清理相关字段
    handlePriorityLesseeTypeChange() {
      this.priorityFormData.certCode = "";
      if (this.priorityFormData.priorityLesseeType === "A11001") {
        this.priorityFormData.certType = undefined;
      } else {
        this.priorityFormData.certType = undefined;
      }

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate(["certType", "certCode"]);
        }
      });
    },

    // 提交
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        const submitData = {
          ...this.priorityFormData,
        };

        if (this.editIndex !== null) {
          // 编辑
          this.$set(this.form.priorityHolder, this.editIndex, {
            ...this.form.priorityHolder[this.editIndex],
            ...submitData,
          });
          this.$notification.success({
            message: "修改优先承租人",
            description: `成功`,
          });
        } else {
          // 新增：严格限制只能有一条
          if (this.form.priorityHolder.length >= 1) {
            this.$notification.warning({
              message: "优先承租人有且只有一个，请编辑或删除现有数据",
              description: `失败`,
            });
            return;
          }

          this.form.priorityHolder.push({
            id: new Date().getTime(),
            ...submitData,
          });
          this.$notification.success({
            message: "新增优先承租人",
            description: `成功`,
          });
        }

        this.closeAddModule();
      });
    },

    // 点击编辑
    editRow(row, index) {
      this.modalType = "edit";
      this.editIndex = index;
      this.priorityFormData = {
        priorityLesseeType: row.priorityLesseeType || "A11001",
        priorityLesseeName: row.priorityLesseeName || "",
        certType:
          row.certType !== undefined && row.certType !== null
            ? row.certType
            : row.priorityLesseeType === "A11002"
            ? ""
            : undefined,
        certCode: row.certCode || "",
      };
      this.addVisible = true;

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 查看
    viewRow(row) {
      this.modalType = "view";
      this.editIndex = null;
      this.priorityFormData = {
        priorityLesseeType: row.priorityLesseeType || "A11001",
        priorityLesseeName: row.priorityLesseeName || "",
        certType:
          row.certType !== undefined && row.certType !== null
            ? row.certType
            : row.priorityLesseeType === "A11002"
            ? "0"
            : undefined,
        certCode: row.certCode || "",
      };
      this.addVisible = true;

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 删除
    deleteRow(index) {
      this.$confirm({
        title: "确认删除？",
        content: "删除后不可恢复",
        onOk: () => {
          this.form.priorityHolder.splice(index, 1);
          this.$notification.success({
            message: "删除优先承租人",
            description: `成功`,
          });
        },
      });
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
}

.add-lessee /deep/ .ant-form-item {
  margin-bottom: 20px;
}

.add-lessee /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}

.add-lessee /deep/ .ant-radio-wrapper {
  line-height: 32px;
}

.add-lessee /deep/ .ant-modal-body {
  padding-top: 12px;
}
</style>